<template>
  <div class="title-one">
    <div class="title-txt">
      {{ title }}
    </div>
    <div class="title-ps">
      {{ psTxt }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TitleOne',
  props: {
    title: {
      type: String,
      default: ''
    },
    psTxt: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
  .title-one{
    width: 100%;
    position: relative;
    font-size: 20px;
    color: #0EFCFF;
  }
  .title-txt{
    width: 333px;
    height: 38px;
    line-height: 1;
    display: flex;
    align-items: center;
    padding-left: 20px;
    background: url("./images/title-bg.png") top left no-repeat;
    background-size: 100% 100%;
    font-weight: 600;
    letter-spacing: 8px;
  }
  .title-ps{
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translate(0, -50%);
    line-height: 1;
  }
</style>
